module.exports = __webpack_public_path__ + "static/media/tut-0.5dc47efd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/tutorial/tut-0.svg
// module id = 182
// module chunks = 0